interface MarkdownDocLike {
    lines: number;
    line(number: number): { text: string };
}

const cachedDocuments = new WeakMap<object, MarkdownDocLike>();

/**
 * CodeMirror's Text.line() walks its tree for every lookup. Rich Markdown
 * scanners make several passes over the same immutable Text instance, so a
 * full-document replacement otherwise repeats that tree walk for every
 * syntax family. Keep one line object per document revision and let the
 * WeakMap release it together with the immutable Text value.
 */
export function withCachedMarkdownDocLines<T extends MarkdownDocLike>(
    document: T,
): MarkdownDocLike {
    const key = document as object;
    const existing = cachedDocuments.get(key);
    if (existing) return existing;

    const lines = new Array<{ text: string } | undefined>(document.lines + 1);
    const cached: MarkdownDocLike = {
        lines: document.lines,
        line(number) {
            const existingLine = lines[number];
            if (existingLine) return existingLine;
            const line = document.line(number);
            lines[number] = line;
            return line;
        },
    };
    cachedDocuments.set(key, cached);
    cachedDocuments.set(cached, cached);
    return cached;
}
